import React from 'react';

const ProtectionOfMinorsContent = () => {
    return (
        <>
            <div className='protection-of-minors'>
                <span>Lębork, dnia 1 sierpnia 2024 r.</span>
                <h2>UCHWAŁA</h2>
                <h2>STOWARZYSZENIA FPUNKT</h2>
                <h2>W SPRAWIE WPROWADZENIA</h2>
                <h2>STANDARDÓW OCHRONY MAŁOLETNICH</h2>
                <p>
                    Dnia 01.08.2024 r. uchwalamy Standardy ochrony małoletnich obowiązujące w ramach każdej
                    aktywności podejmowanej z inicjatywy lub prowadzonej z udziałem Stowarzyszenia FPUNKT.
                    Obowiązują one członków, pracowników, współpracowników, wolontariuszy oraz osoby zatrudnione
                    na podstawie umów cywilnoprawnych Stowarzyszenia FPUNKT oraz wszystkich innych osób
                    skierowanych przez Stowarzyszenie FPUNKT do prowadzenia aktywności, zajęć etc. z udziałem
                    małoletnich w kontakcie z nimi – bezpośrednimi poprzez narzędzia cyfrowe.
                </p>
                <p>Standardy wchodzą w życie z dniem 01.08.2024 r.</p>
                <p>Treść standardów przedstawia Załącznik 1 do niniejszej uchwały.</p>
            </div>
        </>
    );
};

export default ProtectionOfMinorsContent;
